// create global namespace for all JS modules
window.UX = {};
